import React from "react";

const TabsContain: React.FC<{
  handleChangeTab: (value: string) => void;
  activeTab: string;
  sections: string[];
}> = ({ handleChangeTab, activeTab, sections }) => {
  return (
    <div>
      {/* Desktop Tabs */}
      <div className="hidden sm:flex flex-wrap gap-2 mb-6">
        {sections.map((section) => (
          <button
            key={section}
            onClick={() => handleChangeTab(section)}
            className={`px-3 md:px-5 py-2 rounded-full text-sm md:text-base font-medium transition-all
              ${
                activeTab === section
                  ? "bg-primary text-white"
                  : "bg-gray-100 text-gray-700 hover:bg-primary hover:text-white"
              }
            `}
          >
            {section}
          </button>
        ))}
      </div>

      {/* Mobile Horizontal Scroll Tabs */}
      <div className="sm:hidden mb-4 overflow-x-auto scrollbar-hide">
        <div className="flex gap-2 w-max px-1">
          {sections.map((section) => (
            <button
              key={section}
              onClick={() => handleChangeTab(section)}
              className={`whitespace-nowrap px-3 py-2 rounded-full text-xs font-medium transition-all
                ${
                  activeTab === section
                    ? "bg-primary text-white"
                    : "bg-gray-200 text-gray-700 hover:bg-primary hover:text-white"
                }
              `}
            >
              {section}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TabsContain;
